export const coinbaseLogoSvg = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="fill-ock-foreground"
    data-testid="coinbaseLogoSvg"
  >
    <title>Coinbase Pay Onramp</title>
    <path
      d="M7.93154 12.5C5.74045 12.5 3.96577 10.6354 3.96577 8.33333C3.96577 6.03125 5.74045 4.16667 7.93154 4.16667C9.8946 4.16667 11.5239 5.67014 11.8378 7.63889H15.8333C15.4962 3.36111 12.089 0 7.93154 0C3.55267 0 0 3.73264 0 8.33333C0 12.934 3.55267 16.6667 7.93154 16.6667C12.089 16.6667 15.4962 13.3056 15.8333 9.02778H11.8378C11.5239 10.9965 9.8946 12.5 7.93154 12.5Z"
      fill="#0052FF"
    />
  </svg>
);
